import { render } from "./team.vue?vue&type=template&id=5e72f4c9&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"

import "./team.vue?vue&type=style&index=0&id=5e72f4c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e72f4c9"]])

export default __exports__